import { render, staticRenderFns } from "./AddCommentModal.vue?vue&type=template&id=0f85adfb&"
import script from "./AddCommentModal.vue?vue&type=script&lang=js&"
export * from "./AddCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports